import Model from "../Model";

export default class extends Model {
    async loadTable(
      page,
      per_page,
      search = '',
      brand_id = null,
      client_id = null,
      device_type_id = null,
      device_operating_system_id = null,
      device_version_type_id = null,
      date = null,
      currentSortColumn = null,
      currentSortOrder = null
    ) {
        let lastPage = 1;
        let response = await axios.get(this.urls.list, {
            params: {
                page,
                per_page,
                search,
                brand_id,
                client_id,
                device_type_id,
                device_operating_system_id,
                device_version_type_id,
                date,
                currentSortColumn,
                currentSortOrder
            }
        }).then(response => {

            lastPage = response.data.meta.last_page;

            if(response.data.data !== undefined)
            {
                if(response.data.data.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });

        let result = {
            tbody: [],
            pages: lastPage,
        };

        if(response.data !== undefined && response.data.length > 0)
        {
            response.data.forEach(version => {
                let telem = {
                    tbody: {}
                };
                telem.id = version.id;
                telem.tbody.full_version = version.full_version;
                telem.tbody.description = version.description;
                telem.tbody.created_at = version.created_at;
                telem.tbody.updated_at = version.updated_at;
                telem.tbody.device_type = version.device_type.name;
                telem.tbody.compatible_devices = version.compatible_devices;
                telem.tbody.compatible_devices_count = version.compatible_devices_count;
                telem.tbody.is_required = version.is_required;
                telem.tbody.is_hotfix = version.is_hotfix;
                telem.tbody.expiration_date = version.expiration_date;
                telem.tbody.client = version.client.name;
                telem.tbody.brand = version.brand.name;
                telem.tbody.file_path = version.file_path;
                telem.tbody.file_name = version.file_name;
                telem.tbody.access_edit = version.access_edit;
                telem.tbody.os = version.device_operating_system.name
                telem.tbody.device_software_type = version.device_software_type.name;
                result.tbody.push(telem);
            });
        }
        return result;
    }
}
